import { Component } from "react";
import { connect } from "react-redux";
import { CalculatePriceWorker } from "../../../helper/worker/CalculatePriceWorker";
import { DetectOndemandOrReserve } from "../../../helper/worker/DetectOndemandOrReserve";
import { CalculatePriceReserveWorker } from "../../../helper/worker/CalculatePriceReserveWorker";
import { CanOrderCalculateTravelCost } from "../../../helper/worker/CanOrderCalculateTravelCost";
import momentJalaali from "moment-jalaali";
import { EdittPriceNewOrderChanged, EdittPriceNewOrder_manualy, SetPriceNewOrder } from "../../../Redux/actions/actionNames";
import { isEmpty } from "lodash";

class App extends Component {
  componentDidMount() {
    DetectOndemandOrReserve(
      {
        pickup: this.props.pickup,
        dropOffs: [this.props.firstDropOff, this.props.otherdropOffs],
      },
      (call) => {
        if (call === "ondeman") {
          CalculatePriceWorker(
            {
              customerId : this.props.customer?.id ,
              // customerType:this.props.person ? "individual" :"business",
              serviceactiveVehicleType: this.props.serviceactiveVehicleType,
              serviceoptions: this.props.serviceoptions,
              auto: this.props.auto,
              driveroptions: this.props.driveroptions,
              auto_activeVehicleType: this.props.auto_activeVehicleType,
              manual_activeVehicleType:
                this.props.manual_activeVehicleType,
              pickup: {
                address: this.props.pickup.address,
                // block: this.props.pickup.block,
                // floor: this.props.pickup.floor,
                // senderFullName: this.props.pickup.senderFullName,
                // senderPhoneNumber: this.props.pickup.senderPhoneNumber,
                // unit: this.props.pickup.unit,
              },
              pickupadresss_loc: this.props.pickupadresss_loc,
              firstDropOff: {
                address: this.props.firstDropOff.address,
                // block: this.props.firstDropOff.block,
                // floor: this.props.firstDropOff.floor,
                // recieverFullName: this.props.firstDropOff.recieverFullName,
                // recieverPhoneNumber: this.props.firstDropOff.recieverPhoneNumber,
                // unit: this.props.firstDropOff.unit,
              },
              firstDropOffadresss_loc: this.props.firstDropOffadresss_loc,
              // customerType:this.props.person ? "individual" :"business",
              otherdropOffs: this.props.otherdropOffs.map((drop) => {
                return {
                  ...{ address: drop.address },
                  ...{ adresss_loc: drop.adresss_loc },
                  ...{ block: drop.block },
                  ...{ floor: drop.floor },
                  ...{ id: drop.id },
                  ...{ recieverFullName: drop.recieverFullName },
                  ...{ recieverPhoneNumber: drop.recieverPhoneNumber },
                  ...{ unit: drop.unit },
                };
              }),
            },
            this.props.dispatch
          );
          this.props.dispatch(EdittPriceNewOrderChanged(false))

        } else {
          CalculatePriceReserveWorker(
            {
              // customerType:this.props.person ? "individual" :"business",

              customerId : this.props.customer?.id ,
              serviceactiveVehicleType: this.props.serviceactiveVehicleType,
              serviceoptions: this.props.serviceoptions,
              auto: this.props.auto,
              driveroptions: this.props.driveroptions,
              auto_activeVehicleType: this.props.auto_activeVehicleType,
              manual_activeVehicleType:
                this.props.manual_activeVehicleType,
              pickup: {
                address: this.props.pickup.address,
                scheduleDateAfter: momentJalaali(
                  this.props.pickup.scheduleDateAfter
                ).isValid()
                  ? momentJalaali(
                    Number(this.props.pickup.scheduleDateAfter + "000")
                  ).unix()
                  : 0,
                scheduleDateBefore: momentJalaali(
                  this.props.pickup.scheduleDateBefore
                ).isValid()
                  ? momentJalaali(
                    Number(this.props.pickup.scheduleDateBefore + "000")
                  ).unix()
                  : 0,
                // senderFullName: this.props.pickup.senderFullName,
                // senderPhoneNumber: this.props.pickup.senderPhoneNumber,
                // unit: this.props.pickup.unit,
              },
              pickupadresss_loc: this.props.pickupadresss_loc,
              firstDropOff: {
                address: this.props.firstDropOff.address,
                scheduleDateAfter: momentJalaali(
                  this.props.firstDropOff.scheduleDateAfter
                ).isValid()
                  ? momentJalaali(
                    Number(
                      this.props.firstDropOff.scheduleDateAfter + "000"
                    )
                  ).unix()
                  : 0,
                scheduleDateBefore: momentJalaali(
                  this.props.firstDropOff.scheduleDateBefore
                ).isValid()
                  ? momentJalaali(
                    Number(
                      this.props.firstDropOff.scheduleDateBefore + "000"
                    )
                  ).unix()
                  : 0,
                // block: this.props.firstDropOff.block,
                // floor: this.props.firstDropOff.floor,
                // recieverFullName: this.props.firstDropOff.recieverFullName,
                // recieverPhoneNumber: this.props.firstDropOff.recieverPhoneNumber,
                // unit: this.props.firstDropOff.unit,
              },
              firstDropOffadresss_loc: this.props.firstDropOffadresss_loc,
              // customerType:this.props.person ? "individual" :"business",
              otherdropOffs: this.props.otherdropOffs.map((drop) => {
                return {
                  ...{ address: drop.address },
                  ...{ adresss_loc: drop.adresss_loc },
                  ...{ block: drop.block },
                  ...{ floor: drop.floor },
                  ...{ id: drop.id },
                  ...{ recieverFullName: drop.recieverFullName },
                  ...{ recieverPhoneNumber: drop.recieverPhoneNumber },
                  ...{ unit: drop.unit },
                  ...{
                    scheduleDateAfter: momentJalaali(
                      drop.scheduleDateAfter
                    ).isValid()
                      ? momentJalaali(
                        Number(drop.scheduleDateAfter + "000")
                      ).unix()
                      : 0,
                  },
                  ...{
                    scheduleDateBefore: momentJalaali(
                      drop.scheduleDateBefore
                    ).isValid()
                      ? momentJalaali(
                        Number(drop.scheduleDateBefore + "000")
                      ).unix()
                      : 0,
                  },
                };
              }),
            },
            this.props.dispatch
          );
          this.props.dispatch(EdittPriceNewOrderChanged(false))

        }
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    CanOrderCalculateTravelCost(
      {
        customerId : this.props.customer?.id ,
        pickupRequiredCheck: this.pickupRequiredCheck(this.props) , 
        firstDropOffRequiredCheck:this.firstDropOffRequiredCheck(this.props) , 
        otherDropOffRequiredCheck:this.otherDropOffRequiredCheck(this.props),
        calculatedPrice: (this.props.Pricechanged == false && (nextProps.Pricechanged !== this.props.Pricechanged)) ? true : false,
        person: this.props.person,
        serviceactiveVehicleType: this.props.serviceactiveVehicleType,
        serviceoptions: this.props.serviceoptions,
        driveroptions: this.props.driveroptions,
        auto_activeVehicleType: this.props.auto_activeVehicleType,
        manual_activeVehicleType:  this.props.manual_activeVehicleType,
        pickupadresss_loc: this.props.pickupadresss_loc,
        
        pickupscheduleDateAfter: momentJalaali(
          this.props.pickupscheduleDateAfter 
        ).isValid()
          ? momentJalaali(
            Number(this.props.pickupscheduleDateAfter  + "000")
          ).unix()
          : 0,
          pickupscheduleDateBefore: momentJalaali(
            this.props.pickupscheduleDateBefore 
          ).isValid()
            ? momentJalaali(
              Number(this.props.pickupscheduleDateBefore  + "000")
            ).unix()
            : 0,

        firstDropOffadresss_loc: this.props.firstDropOffadresss_loc,
        otherdropOffs: this.props.otherdropOffs.map((drop) => {
          return {
            ...{ adresss_loc: drop.adresss_loc },
          };
        }),
      },
      {
        customerId : nextProps.customer?.id ,
        pickupRequiredCheck: this.pickupRequiredCheck(nextProps) , 
        firstDropOffRequiredCheck:this.firstDropOffRequiredCheck(nextProps) , 
        otherDropOffRequiredCheck:this.otherDropOffRequiredCheck(nextProps),
        calculatedPrice: (nextProps.Pricechanged == true && (nextProps.Pricechanged !== this.props.Pricechanged)) ? false : false,
        person: nextProps.person,
        serviceactiveVehicleType: nextProps.serviceactiveVehicleType,
        serviceoptions: nextProps.serviceoptions,
        driveroptions: nextProps.driveroptions,
        auto_activeVehicleType: nextProps.auto_activeVehicleType ,
        manual_activeVehicleType: nextProps.manual_activeVehicleType,
        pickupadresss_loc: nextProps.pickupadresss_loc,
        pickupscheduleDateAfter: momentJalaali(
          nextProps.pickupscheduleDateAfter 
        ).isValid()
          ? momentJalaali(
            Number(nextProps.pickupscheduleDateAfter  + "000")
          ).unix()
          : 0,
          pickupscheduleDateBefore: momentJalaali(
            nextProps.pickupscheduleDateBefore 
          ).isValid()
            ? momentJalaali(
              Number(nextProps.pickupscheduleDateBefore  + "000")
            ).unix()
            : 0,
        firstDropOffadresss_loc: nextProps.firstDropOffadresss_loc,
        otherdropOffs: nextProps.otherdropOffs.map((drop) => {
          return {
            ...{ adresss_loc: drop.adresss_loc },
          };
        }),
      },
      (call) => {

        console.log("CanOrderCalculateTravelCost ondemand 1 ",call)
        if (call && this.pickupRequiredCheck(nextProps) && this.firstDropOffRequiredCheck(nextProps) && this.otherDropOffRequiredCheck(nextProps)) {
          DetectOndemandOrReserve(
            {
              pickup: nextProps.pickup,
              dropOffs: [nextProps.firstDropOff, nextProps.otherdropOffs],
            },
            (call) => {
              console.log("CanOrderCalculateTravelCost ondemand DetectOndemandOrReserve1 ",call)

              if (call === "ondeman") {
                CalculatePriceWorker(
                  {
                                  customerId : this.props.customer?.id ,

                    // customerType:nextProps.person ? "individual" :"business",
                     PREV : (nextProps.manually_changed && nextProps.PriceCalculated) ? {
                      surcharges: nextProps.PriceCalculated.surcharges.map((surchargesItem)=>{
                        return        {
                          id: surchargesItem.id,
                          surchargeId: surchargesItem.surchargeId,
                          price: surchargesItem.price
                        }
                      }) ,
                      baseFarePrice: nextProps.PriceCalculated.baseFarePrice,
                      tax: nextProps.PriceCalculated.tax,
                      promoCode: nextProps.customer.id.length > 0  ? nextProps.PriceCalculated.promoCode : "",
                      ...nextProps.customer.id.length > 0 ?{  customerId:  nextProps.customer.id } : {}

                    } : null,
                    serviceactiveVehicleType: nextProps.serviceactiveVehicleType,
                    serviceoptions: nextProps.serviceoptions,
                    auto: nextProps.auto,
                    driveroptions: nextProps.driveroptions,
                    auto_activeVehicleType: nextProps.auto_activeVehicleType,
                    manual_activeVehicleType:
                      nextProps.manual_activeVehicleType,
                    pickup: {
                      address: nextProps.pickup.address,
                      // block: nextProps.pickup.block,
                      // floor: nextProps.pickup.floor,
                      // senderFullName: nextProps.pickup.senderFullName,
                      // senderPhoneNumber: nextProps.pickup.senderPhoneNumber,
                      // unit: nextProps.pickup.unit,
                    },
                    pickupadresss_loc: nextProps.pickupadresss_loc,
                    firstDropOff: {
                      address: nextProps.firstDropOff.address,
                      // block: nextProps.firstDropOff.block,
                      // floor: nextProps.firstDropOff.floor,
                      // recieverFullName: nextProps.firstDropOff.recieverFullName,
                      // recieverPhoneNumber: nextProps.firstDropOff.recieverPhoneNumber,
                      // unit: nextProps.firstDropOff.unit,
                    },
                    firstDropOffadresss_loc: nextProps.firstDropOffadresss_loc,
                    // customerType:nextProps.person ? "individual" :"business",
                    otherdropOffs: nextProps.otherdropOffs.map((drop) => {
                      return {
                        ...{ address: drop.address },
                        ...{ adresss_loc: drop.adresss_loc },
                        ...{ block: drop.block },
                        ...{ floor: drop.floor },
                        ...{ id: drop.id },
                        ...{ recieverFullName: drop.recieverFullName },
                        ...{ recieverPhoneNumber: drop.recieverPhoneNumber },
                        ...{ unit: drop.unit },
                      };
                    }),
                  },
                  this.props.dispatch
                );

                this.props.dispatch(EdittPriceNewOrderChanged(false))
              } else {
                CalculatePriceReserveWorker(
                  {
                    // customerType:nextProps.person ? "individual" :"business",
              customerId : this.props.customer?.id ,

                    PREV : ( nextProps.manually_changed &&  nextProps.PriceCalculated) ? {
                      surcharges: nextProps.PriceCalculated.surcharges.map((surchargesItem)=>{
                        return        {
                          id: surchargesItem.id,
                          surchargeId: surchargesItem.surchargeId,
                          price: surchargesItem.price
                        }
                      }) ,
                      baseFarePrice: nextProps.PriceCalculated.baseFarePrice,
                      tax: nextProps.PriceCalculated.tax,
                      promoCode: nextProps.customer.id.length > 0  ? nextProps.PriceCalculated.promoCode : "",
                      ...nextProps.customer.id.length > 0 ?{  customerId:  nextProps.customer.id } : {}

                    } : null,
                    serviceactiveVehicleType: nextProps.serviceactiveVehicleType,
                    serviceoptions: nextProps.serviceoptions,
                    auto: nextProps.auto,
                    driveroptions: nextProps.driveroptions,
                    auto_activeVehicleType: nextProps.auto_activeVehicleType,
                    manual_activeVehicleType:
                      nextProps.manual_activeVehicleType,
                    pickup: {
                      address: nextProps.pickup.address,
                      scheduleDateAfter: momentJalaali(
                        nextProps.pickup.scheduleDateAfter
                      ).isValid()
                        ? momentJalaali(
                          Number(nextProps.pickup.scheduleDateAfter + "000")
                        ).unix()
                        : 0,
                      scheduleDateBefore: momentJalaali(
                        nextProps.pickup.scheduleDateBefore
                      ).isValid()
                        ? momentJalaali(
                          Number(nextProps.pickup.scheduleDateBefore + "000")
                        ).unix()
                        : 0,
                      // senderFullName: nextProps.pickup.senderFullName,
                      // senderPhoneNumber: nextProps.pickup.senderPhoneNumber,
                      // unit: nextProps.pickup.unit,
                    },
                    pickupadresss_loc: nextProps.pickupadresss_loc,
                    // customerType:nextProps.person ? "individual" :"business",
                    firstDropOff: {
                      address: nextProps.firstDropOff.address,
                      scheduleDateAfter: momentJalaali(
                        nextProps.firstDropOff.scheduleDateAfter
                      ).isValid()
                        ? momentJalaali(
                          Number(
                            nextProps.firstDropOff.scheduleDateAfter + "000"
                          )
                        ).unix()
                        : 0,
                      scheduleDateBefore: momentJalaali(
                        nextProps.firstDropOff.scheduleDateBefore
                      ).isValid()
                        ? momentJalaali(
                          Number(
                            nextProps.firstDropOff.scheduleDateBefore + "000"
                          )
                        ).unix()
                        : 0,
                      // block: nextProps.firstDropOff.block,
                      // floor: nextProps.firstDropOff.floor,
                      // recieverFullName: nextProps.firstDropOff.recieverFullName,
                      // recieverPhoneNumber: nextProps.firstDropOff.recieverPhoneNumber,
                      // unit: nextProps.firstDropOff.unit,
                    },
                    firstDropOffadresss_loc: nextProps.firstDropOffadresss_loc,
                    otherdropOffs: nextProps.otherdropOffs.map((drop) => {
                      return {
                        ...{ address: drop.address },
                        ...{ adresss_loc: drop.adresss_loc },
                        ...{ block: drop.block },
                        ...{ floor: drop.floor },
                        ...{ id: drop.id },
                        ...{ recieverFullName: drop.recieverFullName },
                        ...{ recieverPhoneNumber: drop.recieverPhoneNumber },
                        ...{ unit: drop.unit },
                        ...{
                          scheduleDateAfter: momentJalaali(
                            drop.scheduleDateAfter
                          ).isValid()
                            ? momentJalaali(
                              Number(drop.scheduleDateAfter + "000")
                            ).unix()
                            : 0,
                        },
                        ...{
                          scheduleDateBefore: momentJalaali(
                            drop.scheduleDateBefore
                          ).isValid()
                            ? momentJalaali(
                              Number(drop.scheduleDateBefore + "000")
                            ).unix()
                            : 0,
                        },
                      };
                    }),
                  },
                  this.props.dispatch
                );
                this.props.dispatch(EdittPriceNewOrderChanged(false))

              }


              if(nextProps.manually_changed){
                this.props.dispatch(EdittPriceNewOrder_manualy(false))
              }
            }
          );
        }else if(!this.pickupRequiredCheck(nextProps) || !this.firstDropOffRequiredCheck(nextProps) || !this.otherDropOffRequiredCheck(nextProps)){
                this.props.dispatch(SetPriceNewOrder({ done: false }, { done: false ,where:"205" }));
          
        }
      }
    );
  }


    pickupRequiredCheck = (props) => {
      if (props.serviceactiveVehicleType) {
        let name = false, email = false, phone = false;
  
        if (props.serviceactiveVehicleType.setting.isPickupAddressNameRequired) {
          if (props.pickup.senderFullName && String(props.pickup.senderFullName).trim().length > 0) {
            name = true
          } else {
            name = false
          }
        } else {
          name = true
        }
  
        if (props.serviceactiveVehicleType.setting.isPickupAddressPhoneRequired) {
          if (props.pickup.senderPhoneNumber && String(props.pickup.senderPhoneNumber).trim().length > 0) {
            phone = true
          } else {
            phone = false
          }
        } else {
          phone = true
        }
  
  
        if (props.serviceactiveVehicleType.setting.isPickupAddressEmailRequired) {
          if (props.pickup.email && String(props.pickup.email).length > 0 && this.emailValidate(String(props.pickup.email))) {
            email = true
          } else {
            email = false
          }
        } else {
          email = true
        }
  
  
  
        return (name && phone && email);
  
      } else {
        return false
      }
  
    }
  
    firstDropOffRequiredCheck = (props) => {
      if (props.serviceactiveVehicleType) {
        let name = false, email = false, phone = false;
  
        if (props.serviceactiveVehicleType.setting.isDropoffAddressNameRequired) {
          if (props.firstDropOff.recieverFullName && String(props.firstDropOff.recieverFullName).trim().length > 0) {
            name = true
          } else {
            name = false
          }
        } else {
          name = true
        }
  
        if (props.serviceactiveVehicleType.setting.isDropoffAddressPhoneRequired) {
          if (props.firstDropOff.recieverPhoneNumber && String(props.firstDropOff.recieverPhoneNumber).trim().length > 0) {
            phone = true
          } else {
            phone = false
          }
        } else {
          phone = true
        }
  
  
        if (props.serviceactiveVehicleType.setting.isDropoffAddressEmailRequired) {
          if (props.firstDropOff.email && String(props.firstDropOff.email).length > 0 && this.emailValidate(String(props.firstDropOff.email))) {
            email = true
          } else {
            email = false
          }
        } else {
          email = true
        }
  
  
  
        return (name && phone && email);
  
      } else {
        return false
      }
  
    }
  
  
    otherDropOffRequiredCheck = (props) => {
      if (props.serviceactiveVehicleType) {
        if (!isEmpty(props.otherdropOffs)) {
          let status = true;    
    
          props.otherdropOffs.forEach((dropOff, index) => {    
            let name = false, email = false, phone = false;
      
            if (props.serviceactiveVehicleType.setting.isDropoffAddressNameRequired) {
              if (dropOff.recieverFullName && String(dropOff.recieverFullName).trim().length > 0) {
                
  
                name = true
              } else {
                name = false
                status = false
              }
            } else {
              name = true
            }
      
            if (props.serviceactiveVehicleType.setting.isDropoffAddressPhoneRequired) {
              if (dropOff.recieverPhoneNumber && String(dropOff.recieverPhoneNumber).trim().length > 0) {
                
  
                phone = true
              } else {
                phone = false
                status = false
              }
            } else {
              phone = true
            }
      
      
            if (props.serviceactiveVehicleType.setting.isDropoffAddressEmailRequired) {
              if (dropOff.email && String(dropOff.email).length > 0 && this.emailValidate(String(dropOff.email))) {
                
  
                email = true
              } else {
                email = false
                status = false
              }
            } else {
              email = true
            }
      
          });
  
          if (status) {
            return true
          } else {
            return false
          }
      
        } else {
          
          return true
        }
      } else {
        
        return false
      }
  
    }
  
    emailValidate(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    
  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  person: state.NewOrder.newOrder.customer.person,
  serviceactiveVehicleType: state.NewOrder.newOrder.service.activeVehicleType,
  serviceoptions: state.NewOrder.newOrder.service.options,
  Pricechanged: state.NewOrder.newOrder.price.changed,
  manually_changed: state.NewOrder.newOrder.price.changed,
  PriceCalculated: state.NewOrder.newOrder.price.price,
  auto: state.NewOrder.newOrder.driver.auto,
  driveroptions: state.NewOrder.newOrder.driver.options,
  auto_activeVehicleType:
    state.NewOrder.newOrder.driver.auto_driver.auto_activeVehicleType,
  manual_activeVehicleType:
    state.NewOrder.newOrder.driver.manual_driver.manual_activeVehicleType,
  pickup: state.NewOrder.newOrder.pickup,
  pickupadresss_loc: state.NewOrder.newOrder.pickup.adresss_loc,
  firstDropOff: state.NewOrder.newOrder.dropOffs.firstDropOff,
  firstDropOffadresss_loc:
    state.NewOrder.newOrder.dropOffs.firstDropOff.adresss_loc,
  otherdropOffs: state.NewOrder.newOrder.dropOffs.otherDropOffs,
  customer: state.NewOrder.newOrder.customer,
  pickupscheduleDateAfter:state.NewOrder.newOrder.pickup.scheduleDateAfter,
  pickupscheduleDateBefore:state.NewOrder.newOrder.pickup.scheduleDateBefore,


});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
